import React from 'react'

function PrivacyAndTermsModal({setShowPrivacyPopup}) {
  const closePrivacy = () => setShowPrivacyPopup(false);
  return (
     <>
          <div className="mfp-bg mfp-ready"></div>

          <div
            className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
            tabIndex="-1"
            style={{ overflow: "hidden auto" }}
          >
            <div className="mfp-container mfp-s-ready mfp-inline-holder">
              <div className="mfp-content">
                <div
                  id="terms-and-privacy-popup"
                  className="white-popup mfp-with-anim"
                >
                  {/* Inner Banner Area */}
                  <div>
                    <div className="container">
                      <div className="inner-title text-center">
                        <h3
                          style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            fontFamily: "'Poppins', sans-serif",
                            lineHeight: 1.4,
                            color: "#1a1b1e",
                          }}
                        >
                          Terms &amp; Conditions
                        </h3>
                      </div>
                    </div>
                  </div>

                  {/* Terms & Conditions Area */}
                  <div
                    className="terms-conditions-area pt-50 pb-70"
                    style={{ maxHeight: "500px", overflowY: "scroll" }}
                  >
                    <div className="container">
                      <div className="single-content">
                        <p>
                          It is IT DOSE INFOSYSTEMS PVT LTD's policy to respect
                          your privacy regarding any information we may collect
                          while operating our website. This Privacy Policy
                          applies to www.itdoseinfo.com (hereinafter, "us",
                          "we", or "www.itdoseinfo.com"). We respect your
                          privacy and are committed to protecting the personally
                          identifiable information you'll provide us through the
                          website. We've adopted this privacy policy ("Privacy
                          Policy") to elucidate what information may be
                          collected on our Website, how we use this information,
                          and under what circumstances we may disclose the
                          knowledge to 3rd parties. This Privacy Policy applies
                          only to information we collect through the online site
                          and does not apply to our collection of information
                          from other sources. This Privacy Policy, together with
                          the Terms of Service posted on our Website, set forth
                          the general rules and policies governing your use of
                          our Website. Relying on your activities when visiting
                          our Website, you will be required to agree to
                          additional terms of service.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>1. Personally-Identifying Information</h3>
                        <p>
                          Certain visitors to IT DOSE INFOSYSTEMS PVT LTD's
                          websites like better to interact with IT DOSE
                          INFOSYSTEMS PVT LTD in ways that require IT DOSE
                          INFOSYSTEMS PVT LTD to gather personally identifying
                          information. The number and type of information that
                          IT DOSE INFOSYSTEMS PVT LTD gathers depend on the
                          nature of the interaction. As an example, we ask
                          visitors who leave a comment at
                          http://www.itdoseinfo.com/ to provide a username and
                          email address. Sodales vehicula scelerisque.
                          Vestibulum sed auctor arcu, vitae finibus dolor. Nam
                          ultrices consequat odio at gravida.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>2. Security</h3>
                        <p>
                          The security of your Personal Information is important
                          to us, but remember that no method of transmission
                          online, or method of electronic storage is 100%
                          secure. While we try and use commercially acceptable
                          means to protect your Personal Information, we cannot
                          guarantee its absolute security.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>3. Google Remarketing</h3>
                        <p>
                          ITDOSE INFOSYSTEMS PVT LTD uses Google AdWords for
                          remarketing. We use remarketing services to advertise
                          on third-party websites (including Google) to previous
                          visitors to our site. This could mean that we
                          advertise to previous visitors who haven't completed a
                          task on our site, such as using the contact form. Ads
                          may appear on the Google search results page or sites
                          within the Google Display Network. Third-party
                          vendors, including Google, use cookies to serve ads
                          based on someone's past visits. All data collected
                          will be used according to our privacy policy and
                          Google's privacy policy. You can manage your ad
                          preferences on Google's Ad Preferences page or opt out
                          entirely using your browser’s settings or plugins.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>
                          4. Protection of Certain Personally-Identifying
                          Information
                        </h3>
                        <p>
                          IT DOSE INFOSYSTEMS PVT LTD discloses potentially
                          personally identifying and personally identifying
                          information only to employees, contractors, and
                          affiliated organizations that (i) need to know the
                          information to process it or provide services on
                          behalf of IT DOSE INFOSYSTEMS PVT LTD, and (ii) have
                          agreed not to disclose it to others. Some of these
                          parties may be located outside your home country. By
                          using our website, you consent to the transfer of such
                          information. IT DOSE INFOSYSTEMS PVT LTD does not rent
                          or sell this information. We may disclose it only in
                          response to legal processes, or when we believe
                          disclosure is necessary to protect our rights or
                          others. If you are a registered user, we may contact
                          you via email about new features, feedback, or
                          updates. We may publish support requests to help
                          clarify issues or support others. We take reasonable
                          steps to protect against unauthorized access or
                          destruction of data.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>5. Affiliate Disclosure</h3>
                        <p>
                          This site uses affiliate links and may earn a
                          commission from certain links. This does not affect
                          your purchases or the price you may pay.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>6. Cookies</h3>
                        <p>
                          To enhance your experience, we use "Cookies" and
                          similar technologies to personalize content and ads,
                          and store preferences. A cookie is a string of
                          information stored on your computer, which helps us
                          track user preferences. Visitors who do not wish to
                          have cookies placed on their computers should set
                          their browsers to refuse cookies. However, some
                          features may not function properly without cookies.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>7. Privacy Policy Changes</h3>
                        <p>
                          Although most changes are likely to be minor, ITDOSE
                          INFOSYSTEMS PVT LTD may change its Privacy Policy from
                          time to time at its sole discretion. We encourage
                          visitors to check this page frequently. Continued use
                          of our site after changes will constitute acceptance
                          of the updated policy.
                        </p>
                      </div>

                      <div className="single-content">
                        <h3>8. Contact Information &amp; Credit</h3>
                        <p>
                          This privacy policy was created using privacyterms.io.
                          If you have any questions about our Privacy Policy,
                          please contact us via email or phone.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Close Button */}
                  <button
                    title="Close"
                    type="button"
                    className="mfp-close"
                    onClick={closePrivacy}
                  >
                    ×
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
  )
}

export default PrivacyAndTermsModal